import type { ReactNode } from 'react';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonRefresher, IonRefresherContent, IonTitle, IonToolbar } from '@ionic/react';
import { cn } from '@tcrd/ui';

export interface PageProps {
  title: string;
  children: ReactNode;
  back?: string;
  actions?: ReactNode;
  onRefresh?: () => Promise<unknown>;
  /** Sin padding ni ancho máximo (mapas a pantalla completa). */
  bleed?: boolean;
  footer?: ReactNode;
  hideHeader?: boolean;
  /** Muestra el logo en lugar del título (el título queda para lectores de pantalla); 'left' lo alinea a la izquierda. */
  logo?: boolean | 'left';
}

export function Page({ title, children, back, actions, onRefresh, bleed, footer, hideHeader, logo }: PageProps) {
  return (
    <IonPage>
      {!hideHeader && (
        <IonHeader className="ion-no-border">
          <IonToolbar>
            {back && (
              <IonButtons slot="start">
                <IonBackButton defaultHref={back} text="" />
              </IonButtons>
            )}
            {logo === 'left' && (
              <IonButtons slot="start">
                <span className="sr-only">{title}</span>
                <img src="/brand/logo-dark.png" alt="TuConductorRD" className="h-11 w-auto ml-2 dark:hidden" />
                <img src="/brand/logo-white.png" alt="TuConductorRD" className="h-11 w-auto ml-2 hidden dark:block" />
              </IonButtons>
            )}
            <IonTitle className="font-bold">
              {logo === 'left' ? null : logo ? (
                <span className="flex justify-center">
                  <span className="sr-only">{title}</span>
                  <img src="/brand/logo-dark.png" alt="TuConductorRD" className="h-12 w-auto dark:hidden" />
                  <img src="/brand/logo-white.png" alt="TuConductorRD" className="h-12 w-auto hidden dark:block" />
                </span>
              ) : (
                title
              )}
            </IonTitle>
            {actions && <IonButtons slot="end">{actions}</IonButtons>}
          </IonToolbar>
        </IonHeader>
      )}
      <IonContent fullscreen={bleed}>
        {onRefresh && (
          <IonRefresher slot="fixed" onIonRefresh={(e) => void onRefresh().finally(() => e.detail.complete())}>
            <IonRefresherContent />
          </IonRefresher>
        )}
        <div className={cn(!bleed && 'mx-auto w-full max-w-3xl px-4 py-4 pb-28', bleed && 'h-full')}>{children}</div>
      </IonContent>
      {footer}
    </IonPage>
  );
}
